var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewUploadIsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 77,
    viewBox: "0 0 56 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.106445,
    y: 0.0444336,
    width: 55.8935,
    height: 76.4114,
    fill: "#D2EEF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.01508,
    y: 6.79932,
    width: 44.7492,
    height: 4.22162,
    fill: "#77BACE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.01508,
    y: 15.2422,
    width: 44.7492,
    height: 18.5751,
    fill: "#DCF6FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.01508,
    y: 37.1943,
    width: 44.7492,
    height: 18.5751,
    fill: "#DCF6FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.01508,
    y: 61.6802,
    width: 4.22162,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0827,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6144,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.059,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5252,
    y: 61.6802,
    width: 1.68865,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3029,
    y: 61.6802,
    width: 3.3773,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7475,
    y: 61.6802,
    width: 4.22162,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6562,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6325,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1008,
    y: 61.6802,
    width: 1.68865,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.8785,
    y: 61.6802,
    width: 3.3773,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42.321,
    y: 61.6802,
    width: 4.22162,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3886,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9203,
    y: 61.6802,
    width: 0.844325,
    height: 9.28757,
    fill: "#77BACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewUploadIsa);
export default __webpack_public_path__ + "static/media/preview_upload_isa.03a3d2f6b2e16005e0a6c041ef32cf0c.svg";
export { ForwardRef as ReactComponent };